import React, { useState } from 'react'
import edit from "../../Assets/edit-comp-action.svg"
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ConfirmDeleteModal from '../../Components/Modals/OrganizerModel/ManageFeis/Tabulate/ConfirmDeleteModal';
import { serviceConsumer } from '../../network/ServiceConsumer';
import Loader from '../../Components/Loader/Loader';
import { ShowToastMessage } from '../../helper/ShowToastMessage';
import { Avatar } from "@mui/material";
import AddCollabModal from '../../Components/Modals/OrganizerModel/ManageCollab/AddCollabModal';
import AdjudicatorStatus, { adjudicatorStatusOf } from '../../Components/AdjudicatorStatus/AdjudicatorStatus';

const shortDate = (d) => (d ? new Date(d).toLocaleDateString("en-CA", { month: "short", day: "numeric" }) : "");

// "Invited Oct 27 · 2 reminders" for a pending adjudicator (card 930d3ac0).
const inviteDetail = (collab) => {
    const inv = collab?.invite;
    if (!inv || inv.status !== "invited") return "";
    const n = inv.remindersSent || 0;
    return `Invited ${shortDate(inv.sentAt)}${n ? ` · ${n} reminder${n === 1 ? "" : "s"}` : ""}`;
};

const CollaboratorTable = ({ list, page, getCollabs, }) => {
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [editCollab, setEditCollab] = useState("")
    const [deleteCollab, setDeleteCollab] = useState("")

    const serializeHelper = (page - 1) * 10

    const editClickHandler = (collab) => {
        setEditCollab(collab)
        setOpenEditModal(true)
    }

    const deleteClickHandler = (collab) => {
        setDeleteCollab(collab)
        setOpenDeleteModal(true)
    }

    const confirmDeleteHandler = async () => {
        try {
            setLoading(true)
            const url = `${process.env.REACT_APP_BASE_URL}/people/${deleteCollab?._id}`;
             await serviceConsumer("DELETE", url)
            ShowToastMessage("success", "Collaborator deleted successfully")
            setOpenDeleteModal(false)
            getCollabs()
            setLoading(false)
        } catch (err) {
            setLoading(false)
            ShowToastMessage("error", "Something went wrong")
        }
    }

    // Send the account invitation now, or again with the same link.
    const sendInviteHandler = async (collab) => {
        try {
            setLoading(true)
            const url = `${process.env.REACT_APP_BASE_URL}/people/${collab?._id}/invite`;
            const res = await serviceConsumer("POST", url, {})
            setLoading(false)
            if (res?.success === false) return ShowToastMessage("error", res.message || "Something went wrong")
            ShowToastMessage("success", `Invitation sent to ${collab?.email}`)
            getCollabs()
        } catch (err) {
            setLoading(false)
            ShowToastMessage("error", err?.messages || "Something went wrong")
        }
    }

    const cancelDeleteHandler = () => {
        setOpenDeleteModal(false)
    }

    const closeEditModal = () => {
        setOpenEditModal(false)
    }

    return (
        <div style={{ width: "100%", overflowX: "scroll", marginTop: "30px", marginBottom: "50px" }}>
            {loading && <Loader />}
            <table className="table my_table competitorTable ">
                <tbody>
                    <tr className="header-row">
                        <td className="mx-5 w-3 p-25 text-center">S.No</td>
                        <td className="mx-5 w-8 p-25-5">Profile</td>
                        <td className="mx-5 w-8 p-25 ">First Name</td>
                        <td className="mx-5 w-8 p-25 ">Last Name</td>
                        <td className="mx-5 w-8 p-25 ">Region</td>
                        <td className="mx-5 w-8 p-25 ">Type</td>
                        <td className="mx-5 w-10 p-25 ">Account</td>
                        <td className="mx-5 w-10 text-center p-25-5">Actions</td>
                    </tr>
                    {list?.map((collab, index) => {
                        return <tr key={collab?._id} style={{ fontSize: "12px", height: "61px" }}>
                            <td className="mx-5 w-3 p-25 text-center">{serializeHelper + (index + 1)}</td>
                            <td className="mx-5 w-8 p-25-5">
                                <Avatar style={{ width: "50px", height: "50px" }} src={collab?.photo} alt="profile" />
                            </td>
                            <td className="mx-5 w-8 p-25 ">{collab?.fname}</td>
                            <td className="mx-5 w-8 p-25 ">{collab?.lname}</td>
                            <td className="mx-5 w-8 p-25 ">{collab?.location}</td>
                            <td className="mx-5 w-8 p-25 ">{collab?.type}</td>
                            <td className="mx-5 w-10 p-25 ">
                                {collab?.type === "adjudicator" && (() => {
                                    const status = adjudicatorStatusOf(collab)
                                    return <div className="d-grid" style={{ gap: "3px", justifyItems: "start" }}>
                                        <AdjudicatorStatus status={status} />
                                        {collab?.email && <span style={{ color: "#797979" }}>{collab.email}</span>}
                                        {status === "invited" && <span style={{ color: "#797979" }}>{inviteDetail(collab)}</span>}
                                        {(status === "email" || status === "invited") && (
                                            <button
                                                type="button"
                                                style={{ color: "#68ad3f", cursor: "pointer", fontWeight: 500, background: "none", border: "none", padding: 0, fontSize: "12px" }}
                                                onClick={() => sendInviteHandler(collab)}
                                            >
                                                {status === "invited" ? "Resend invitation" : "Send invitation"}
                                            </button>
                                        )}
                                    </div>
                                })()}
                            </td>

                            <td className="w-10 text-center ">
                                <div className="d-flex justify-content-center gap-3">
                                    <img onClick={() => editClickHandler(collab)} style={{ cursor: "pointer" }} src={edit} alt="edit" />
                                    <DeleteOutlineOutlinedIcon
                                        style={{ color: "red", marginLeft: "10px", cursor: "pointer" }}
                                        onClick={() => deleteClickHandler(collab)}
                                    />
                                </div>
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>
            {openDeleteModal && <ConfirmDeleteModal modalState={openDeleteModal} confirm={confirmDeleteHandler} cancel={cancelDeleteHandler} dancerPage={true} />}
            {openEditModal && <AddCollabModal addOrEdit="Edit" onClose={closeEditModal} editCollab={editCollab} getList={getCollabs} />}
        </div>
    )
}

export default CollaboratorTable
